// here you define the types of app instance resources you have
// eslint-disable-next-line import/prefer-default-export
export const TOUR_TAKEN = 'TOUR_TAKEN';
